import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=2daa95dc&scoped=true"
import script from "./Sales.js?vue&type=script&lang=js&external"
export * from "./Sales.js?vue&type=script&lang=js&external"
import style0 from "./Sales.scss?vue&type=style&index=0&id=2daa95dc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa95dc",
  null
  
)

export default component.exports